import Cookies from 'js-cookie'

const TokenKey = 'x-access-token'

export function getToken() {
    return Cookies.get(TokenKey, {
        domain: process.env.NODE_ENV === 'production' ? '.szsn.tx369.com' : '192.168.31.60'
    })
}

export function setToken(token) {
    return Cookies.set(TokenKey, token, {
        domain: process.env.NODE_ENV === 'production' ? '.szsn.tx369.com' : '192.168.31.60',
        expires: 365
    })
}

export function removeToken() {
    return Cookies.remove(TokenKey, {
        domain: process.env.NODE_ENV === 'production' ? '.szsn.tx369.com' : '192.168.31.60'
    })
}
